import store from "@/store/store"

export function getEntity(entityKey) {
    return store.getters["schema/getEntity"](entityKey);
}

export function getEnums() {
    return store.getters["schema/enums"];
}

export function getEnum(enumKey) {
    return store.getters["schema/getEnum"](enumKey);
}

export function getEndpoint(entityKey, endpointKey, scope) {
    const entity = getEntity(entityKey)
    if (entity == null) {
        return undefined
    }

    const scopeEndpoints = entity.endpoints[endpointKey]
    if (scopeEndpoints == null) {
        return undefined
    }

    const userPolicies = store.state.authentication.user.policies || []

    let endpointScope = null

    // If scope is provided, try to find that specific scope
    if (scope) {
        endpointScope = scopeEndpoints.scopes.find(s => s.key === scope)
    } else {
        // If no scope provided, find the first scope where user has the required policy
        endpointScope = scopeEndpoints.scopes.find(s =>
            s.policies && s.policies.some(policy => userPolicies.includes(policy))
        )
    }

    if (endpointScope == null) {
        return undefined
    }

    // Only return the endpoint if the user has the required policies
    if (!endpointScope.policies || !endpointScope.policies.some(policy => userPolicies.includes(policy))) {
        return undefined
    }

    return {
        key: endpointKey,
        method: scopeEndpoints.method,
        scope: endpointScope.key,
        path: endpointScope.path,
        policies: endpointScope.policies
    }
}

export function getQueryField(entityKey, fieldKey) {
    return store.getters["schema/getQueryField"](entityKey, fieldKey);
}

export function getDependants(entityKey) {
    const entities = store.getters["schema/entities"];

    // get an array of { entity, field } for fields which depend on the given entityKey.
    return Object.values(entities)
        .map(entity => Object
            .values(entity.queryFields)
            .filter(field => field.dependsOn?.entityKey === entityKey)
            .map(field => ({ entity, field })))
        .flat();
}

export function getType(entityKey, fieldKey) {
    const field = getQueryField(entityKey, fieldKey);

    if (field == null) {
        throw new Error(`Schema field not found: '${entityKey}.${fieldKey}'.`);
    }

    return field.type;
}
